import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import * as Layout from 'arm-core-layouts';
import DocumentiActions from './DocumentiActions';
import { i18n } from 'arm-common';
import { isNullOrUndefined } from 'util';

class ConfermaNuovaVersioneDoc extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[ConfermaNuovaVersioneDoc.jsx] ";

        this.state = {
            validation: new Map(),
            dataInizioVal: null,
            nuovaVersioneDocumento: {}
        };

        this.dataValChangeHandler = this.dataValChangeHandler.bind(this);
        this.hideNewVersionPopup = this.hideNewVersionPopup.bind(this);
        this.showNewDocumentVersion = this.showNewDocumentVersion.bind(this);
        this.salvaNuovaVersioneDocumento = this.salvaNuovaVersioneDocumento.bind(this);
    }

    dataValChangeHandler(e) {
        console.log("dataValChangeHandler");
        if (e) {
            this.setState({ dataInizioVal: e });
        }
    }

    isFormValid(){
        if(this.state.dataInizioVal){
            let localValidation = new Map(this.state.validation);
            let startTime = this.state.dataInizioVal.getTime();
            let currDocumentStartDate = this.props.documento.dataInizio;
            let today = new Date(Number(new Date().getTime())).setHours(0, 0, 0, 0);
            
            if (!isNullOrUndefined(startTime)) {
                startTime = new Date(Number(startTime)).setHours(0, 0, 0, 0);
            }

            if (!isNullOrUndefined(currDocumentStartDate)) {
                currDocumentStartDate = new Date(Number(currDocumentStartDate)).setHours(0, 0, 0, 0);
            }

            if (isNullOrUndefined(startTime)) {
                localValidation.set("dataInizioNuovaVersione", i18n('ARM_CORE_PRINT.NUOVA_VERSIONE.ASSENZA_DATA_INIZIO_VALIDITA', "Inserire una data di inizio validità!"));
                this.setState({ validation: localValidation });
                return false;
            }

            if (startTime < today) {
                localValidation.set("dataInizioNuovaVersione", i18n('ARM_CORE_PRINT.NUOVA_VERSIONE.ERRORE_DATA_INIZIO_VALIDITA', "Inserire una data di inizio validità corretta"));
                this.setState({ validation: localValidation });
                return false;
            }

            if (!isNullOrUndefined(currDocumentStartDate) && startTime < currDocumentStartDate) {
                localValidation.set("dataInizioNuovaVersione", i18n('ARM_CORE_PRINT.NUOVA_VERSIONE.ERRORE_DATA_INIZIO_VALIDITA', "Inserire una data di inizio validità corretta"));
                this.setState({ validation: localValidation });
                return false; 
            }
            return true;
        }
    }

    salvaNuovaVersioneDocumento() {
        console.log(this.componentName + " salvaNuovaVersioneDocumento: ");

        if(this.isFormValid()){
            this.props.salvaNuovaVersioneDoc(this.state.dataInizioVal).then(
                resolve => {
                    console.log('Id nuova versione documenti: ' + resolve.id
                        + ' id documento padre: ' + resolve.idPadre);
                    this.hideNewVersionPopup();
                    this.setState({ nuovaVersioneDocumento: resolve });
                    this.showNewDocumentVersion();
                }, reject => {
                    console.log(this.componentName + " salvaNuovaVersioneDocumento: KO ");
                    console.log(reject);
                    this.hideNewVersionPopup();
                }
            );
        }
        
    }

    showNewDocumentVersion() {
        this.props.setIsAlreadyExistingDoc(true);
        this.props.getDocumentById(this.state.nuovaVersioneDocumento.id);
        this.props.updateIdUltimaVersioneDocumento(this.state.nuovaVersioneDocumento.id);
    }

    hideNewVersionPopup() {
        if (this.props.showConfermaNuovaVersione) {
            this.toggleShowConfermaNuovaVersione();
            this.setState({ dataInizioVal: null });
        }
    }

    toggleShowConfermaNuovaVersione() {
        this.props.toggleShowConfermaNuovaVersione();
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="mt-3">
                <agui.PopupResponsive className='confermaNuovaVersionePopup' show={this.props.showConfermaNuovaVersione}>
                    <agui.PopupResponsive.Header>
                        {i18n('ARM_CORE_PRINT.NUOVA_VERSIONE.TITOLO', "Nuova versione")}
                    </agui.PopupResponsive.Header>
                    <agui.PopupResponsive.Body>
                        <Layout.VBox>
                            <agui.CoolTextInput required={true} disabled={true} id="version" label={i18n('ARM.CORE.PRINT.VERSION', 'Versione')} value={( parseInt(this.props.documento.nomeVersione) + 1 || '1') + ''}></agui.CoolTextInput>
                            <agui.CoolDateInput required={true}
                                value={this.state.dataInizioVal}
                                onChange={(e) => this.dataValChangeHandler(e)}
                                label={i18n('ARM.CORE.PRINT.DATA.INIZIO', "Data inizio validità")}
                                id="dataInizioNuovaVersione"
                                validation={this.state.validation}
                            ></agui.CoolDateInput>
                        </Layout.VBox>
                    </agui.PopupResponsive.Body>
                    <agui.PopupResponsive.Footer>
                        <Layout.HBox>
                            <agui.LineBar>
                                <agui.LineBarGroup>
                                    <agui.aButton 
                                        disabled = {!this.state.dataInizioVal}
                                        onClick={() => this.salvaNuovaVersioneDocumento()} bs='primary'>{i18n('ARM_CORE_PRINT.MANAGE.SALVA', "Salva")}</agui.aButton>
                                </agui.LineBarGroup>
                                <agui.LineBarGroup right={true}>
                                    <agui.aButton bs="secondary"
                                        onClick={() => this.hideNewVersionPopup()}>{i18n('ARM_CORE_PRINT.SHARED.ANNULLA', "Annulla")}</agui.aButton>
                                </agui.LineBarGroup>
                            </agui.LineBar>
                        </Layout.HBox>
                    </agui.PopupResponsive.Footer>
                </agui.PopupResponsive>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        salvaNuovaVersioneDoc(dataInizioVal) {
            return dispatch(DocumentiActions.salvaNuovaVersioneDoc(dataInizioVal));
        },
        toggleShowConfermaNuovaVersione() {
            return dispatch(DocumentiActions.toggleMostraPopupConfermaNuovaVersione());
        },
        setIsAlreadyExistingDoc(newState) {
            return dispatch(DocumentiActions.setIsAlreadyExistingDoc(newState));
        },
        getDocumentById(id) {
            return dispatch(DocumentiActions.getDocumentById(id))
        },
        updateIdUltimaVersioneDocumento(newVersionId) {
            return dispatch(DocumentiActions.updateIdUltimaVersioneDocumento(newVersionId));
        }
    }
};


function mapStateToProps(state) {
    return {
        documento: state.documentiReducer.documento,
        showConfermaNuovaVersione: state.documentiReducer.showConfermaNuovaVersione
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfermaNuovaVersioneDoc);